import { Component } from "@angular/core";
import { NavParams } from "ionic-angular";
import { Signaltag } from "../../models/trend-live-models/OPTag";

/**
 * Generated class for the TrendExplorerTagListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "trend-explorer-tag-list",
  templateUrl: "trend-explorer-tag-list.html",
})
export class TrendExplorerTagListComponent {
  trainTags: Signaltag[] = [];

  constructor(params: NavParams) {
    console.log(params);
  }
}



// WEBPACK FOOTER //
// ./src/components/trend-explorer-tag-list/trend-explorer-tag-list.ts